<template>
  <div class="change-transaction-category-popup">
    <colored-popup :class="categoryToVariant[selectedCategory.cashflowCategory]" :close-action="close">

      <template v-slot:top-content>
        <div class="expense-title">
          <span class="name">{{ incomeOrExpense }} {{ selectedCategory.label }}</span>
        </div>
        <transaction-details :transaction="transaction" />
      </template>

      <template v-slot:bottom-content>
        <div class="question">איזו {{ incomeOrExpense }} זו?</div>
        <cashflow-category-dropdown :options="availableCategories"
                  :selected="selectedCategory"
                  :on-select="onSelection"
                  :on-drop-down-change="onDropdownOpened"/>
        <riseup-button :action="onSave"
                       :variant="'secondary-black'"
                       :title="'שמירה'"
                       :disabled="sameCategorySelected"/>
      </template>

    </colored-popup>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import BaseUI from 'base-ui';
import TransactionDetails from './TransactionDetails.vue';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import Segment from '../../../../../../../../../../Segment';
import cashflowViewConsts from '../../../../../../../../../../constants/cashflow-view';

export default {
  name: 'ChangeTransactionCategoryPopup',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    TransactionDetails,
    CashflowCategoryDropdown: BaseUI.CashflowCategoryDropdown,
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      dropdownOpened: true,
    };
  },
  created() {
    Segment.trackUserInteraction('ChangeTransactionCategoryPopup_Shown', {
      businessName: this.transaction.businessName,
      originalCategory: this.transaction.expense,
    });
  },
  computed: {
    ...mapState('editTransaction', ['transaction', 'selectedCategoryName', 'originalCategoryName']),
    ...mapGetters('editTransaction', [
      'sameCategorySelected', 'selectedCategory', 'availableCategories', 'categoryToVariant', 'originalCategory', 'incomeOrExpense',
    ]),
  },
  methods: {
    ...mapMutations('editTransaction', ['setSelectedCategoryName', 'setSelectedCategoryId']),
    close() {
      Segment.trackUserInteraction('ChangeTransactionCategoryPopup_CloseClicked', {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
      });
      this.$emit('close');
    },
    onSelection(category) {
      if (category.categoryName === cashflowViewConsts.CATEGORY_NAMES.TRACKING) {
        this.setSelectedCategoryId(category.categoryId);
      } else {
        this.setSelectedCategoryName(category.categoryName);
      }
    },
    onSave() {
      Segment.trackUserInteraction('ChangeTransactionCategoryPopup_SaveClicked', {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
        selectedCategory: this.selectedCategory.expense,
      });
      ModalBus.$emit('open', {
        component: this.originalCategory.originalPopup || this.selectedCategory.targetPopup,
        props: {},
      });
    },
    onDropdownOpened(isOpen) {
      this.dropdownOpened = isOpen;
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .change-transaction-category-popup {
    text-align: right;

    .colored-top {
      color: $riseup_white;

      .expense-title {
        margin-bottom: 16px;
        line-height: 11px;

        .name, .dot{
          font-weight: bold;
        }
      }
    }

    .bottom {
      .question {
        line-height: 13px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .cashflow-category-dropdown {
        margin-bottom: 40px;
      }

      .riseup-button {
        width: 100%;
      }
    }
  }

</style>
